"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var unit = 4;
var spacing = {
    xxsmall: unit + 'px',
    xsmall: unit * 2 + 'px',
    small: unit * 4 + 'px',
    medium: unit * 6 + 'px',
    large: unit * 8 + 'px',
    xlarge: unit * 10 + 'px',
    xxlarge: unit * 14 + 'px'
};
exports.default = spacing;
//# sourceMappingURL=spacing.js.map